import gql from "graphql-tag";

export const RELEASE_ALL_REBATE = gql`
  mutation ($id: String!) {
    releaseAllRebateItems(rebateId: $id)
  }
`;
